export default class FormItemLongResolver
{
	
	static LONG_MAX =999999999999999;
	static LONG_MIN = -999999999999999;
	
	static formatResult(value)
	{
		var reg1 = /^-0+$/;
		var reg2 = /^0+$/;
		
		if(reg1.exec(value)!=null)
		{
			return "0";
		}
		
		if(reg2.exec(value)!=null)
		{
			return "0"
		}
		return value;
		
	}
	
	
	static getResult()
	{
		var input = arguments[0];
		var notnull = arguments[1];
		var allowNegative = arguments[2];
		if(input == "")
			input = "0";
		if(typeof(input) == "number")
		{
			input = input+"";
		}
		var regFloat = /^(-?\d+)(\.\d+)?$/;
		var regInteger = /^-?\d+$/;
		var result;
		
		if(regInteger.exec(input)!=null )
		{
			
			//匹配整数成功
			
			if(input.charAt(0) == "-")
			{
				if(!allowNegative)
				{
					result = Math.abs(Number(input));
					if(result > FormItemLongResolver.LONG_MAX)
						return "false:max";
					if(result == 0 && notnull)
						return "false:不允许为空";
					return input.substr(1); 
					//String(Math.abs(Number(input)));
				}
				else
				{
					result = Number(input);
					if(result < FormItemLongResolver.LONG_MIN)
						return "false:min";
				}
			}
			
			result = Number(input)
			if(result > FormItemLongResolver.LONG_MAX)
				return "false:max";
			if(result == 0 && notnull)
				return "false:不允许为空";
			return FormItemLongResolver.formatResult(input);
			//return value;
			
		}
		
		if(regFloat.exec(input)!=null)
		{
			//匹配浮点数
			if(input.charAt(0) == "-")
			{
				if(!allowNegative)
				{
					result = Math.abs(Number(input));
					if(result > FormItemLongResolver.LONG_MAX)
						return "false:max";
					//var number:Number = Math.abs(Number(value));
					if(result == 0 && notnull)
						return "false:不允许为空";
					return input.substr(1);
				}
				else
				{
					result = Number(input);
					if(result < FormItemLongResolver.LONG_MIN)
						return "false:min";
				}
				
			}
			
			result = Number(input)
			if(result > FormItemLongResolver.LONG_MAX)
				return "false:max";
			if(result == 0 && notnull)
				return "false:不允许为空";
			return input;
			
		}
		
		return "false:输入格式有误";
	}
}




// WEBPACK FOOTER //
// ./src/formItem/resolver/FormItemLongResolver.js